import {
  Checkbox,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { useTranslate } from 'src/localization/Trns'
import { ConnectedPlatformStatus } from 'src/models/transaction.models'
import { css } from 'styled-components'

interface TransactionSyncStatusFilterProps {
  syncStatusesSet: Set<string>
  handleSyncStatusesSelection: (status: string) => Set<string>
  activeIntegration: any
}

const TransactionSyncStatusFilter: React.FC<
  TransactionSyncStatusFilterProps
> = ({ syncStatusesSet, handleSyncStatusesSelection, activeIntegration }) => {
  const translate = useTranslate()

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 12px;
      `}
    >
      <div
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        {translate('Transaction Sync')}
      </div>
      <Checkbox
        label={translate('Synced')}
        onClick={(): void => {
          handleSyncStatusesSelection(ConnectedPlatformStatus.Success)
        }}
        isSelected={syncStatusesSet.has(ConnectedPlatformStatus.Success)}
      />
      <Checkbox
        label={translate('Not synced')}
        onClick={(): void => {
          handleSyncStatusesSelection(ConnectedPlatformStatus.NotSynced)
        }}
        isSelected={syncStatusesSet.has(ConnectedPlatformStatus.NotSynced)}
      />
      <Checkbox
        label={translate('Sync failed')}
        onClick={(): void => {
          handleSyncStatusesSelection(ConnectedPlatformStatus.Failed)
        }}
        isSelected={syncStatusesSet.has(ConnectedPlatformStatus.Failed)}
      />
      <Checkbox
        label={translate('Sync in progress')}
        onClick={(): void => {
          handleSyncStatusesSelection(ConnectedPlatformStatus.Pending)
        }}
        isSelected={syncStatusesSet.has(ConnectedPlatformStatus.Pending)}
      />
    </div>
  )
}

export default TransactionSyncStatusFilter
